"use client";

import { useEffect } from "react";

/** 各页面共用的错误展示：通常是后端未启动或返回了错误。 */
export default function RouteError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="page">
      <div className="error-box" role="alert">
        <strong>页面加载失败</strong>
        <p style={{ margin: "6px 0 10px" }}>{error.message || "发生未知错误"}</p>
        <button type="button" className="btn" onClick={reset}>
          重试
        </button>
      </div>
    </div>
  );
}
